module.exports = __webpack_public_path__ + "static/img/bg-en.8c0c0787.png";